import React from 'react';
import { AIChatInterface } from '../../shared/AIChatInterface';
import { AIDescriptionChatContext } from './AIDescriptionChatContext';
import { AIDescriptionSuggestedActions } from './AIDescriptionSuggestedActions';

// Re-export ChatMessage type for backward compatibility
export type { ChatMessage } from '../../shared/AIChatInterface';

interface AIDescriptionChatProps {
  messages: any[];
  isLoading: boolean;
  userInput: string;
  onUserInputChange: (value: string) => void;
  onSendMessage: () => void;
  disabled?: boolean;
  selectedContext?: string;
  onClearContext?: () => void;
  hasInitialDescription?: boolean;
  currentDescription?: string;
  onSendPrompt?: (prompt: string) => void;
  focusTriggerRef?: React.MutableRefObject<(() => void) | undefined>;
}

export const AIDescriptionChat: React.FC<AIDescriptionChatProps> = ({
  messages,
  isLoading,
  userInput,
  onUserInputChange,
  onSendMessage,
  disabled = false,
  selectedContext,
  onClearContext,
  hasInitialDescription = false,
  currentDescription = '',
  onSendPrompt,
  focusTriggerRef,
}) => {
  // Show suggested actions if there's any description content (initial or AI-generated)
  const hasDescription = hasInitialDescription || (currentDescription && currentDescription.trim().length > 0);
  return (
    <AIChatInterface
      messages={messages}
      isLoading={isLoading}
      userInput={userInput}
      onUserInputChange={onUserInputChange}
      onSendMessage={onSendMessage}
      disabled={disabled}
      placeholder="Describe this task..."
      loadingMessage="Generating..."
      defaultPrompt={
        !hasInitialDescription
          ? {
              text: 'Generate description based on the Task title and other existing Tasks.',
              buttonLabel: 'Generate with AI based only on Task title and other Tasks',
            }
          : undefined
      }
      showDefaultPrompt={!hasInitialDescription}
      contextBanner={
        selectedContext && onClearContext ? (
          <AIDescriptionChatContext selectedText={selectedContext} onClear={onClearContext} />
        ) : undefined
      }
      suggestedActions={
        hasDescription && onSendPrompt && !isLoading ? (
          <div className="px-2 pb-1">
            <AIDescriptionSuggestedActions onActionClick={onSendPrompt} disabled={disabled} />
          </div>
        ) : undefined
      }
      onSendPrompt={onSendPrompt}
      focusTriggerRef={focusTriggerRef}
    />
  );
};
